import { Filter, IActiveFilters, SelectList, NumberRange, SelectListMulti } from 'api-paths-cas';
import { SelectMany } from './SelectMany';
import { SelectOne } from './SelectOne';
import get from 'lodash/get';
import { NumberRangeFilter } from './NumberRange';
import { SelectManyMulti } from './SelectManyMulti';

export interface IProps {
  filter: Filter;
  list: SelectList | NumberRange | SelectListMulti;
  activeFilters: IActiveFilters;
}

export interface IDispatchProps {
  saveFilter: (key: string, values: string[] | number[]) => void;
}

export const FilterType = ({ filter, list, activeFilters, saveFilter }: IProps & IDispatchProps) => {
  if (filter.options?.SELECT_MANY) {
    return (
      <SelectMany list={list as SelectList} filter={filter} activeFilters={activeFilters} saveFilter={saveFilter} />
    );
  }

  if (filter.options?.SELECT_MANY_MULTI) {
    return (
      <SelectManyMulti
        list={list as SelectListMulti}
        filter={filter}
        activeFilters={activeFilters}
        saveFilter={saveFilter}
      />
    );
  }

  if (filter.options?.SELECT_ONE) {
    const active: string = get(activeFilters, [filter.key, '0']);
    return <SelectOne list={list as SelectList} filter={filter} active={active} saveFilter={saveFilter} />;
  }

  if (filter.options?.NUMBER_RANGE) {
    return (
      <NumberRangeFilter
        list={list as NumberRange}
        saveFilter={saveFilter}
        activeFilters={activeFilters}
      ></NumberRangeFilter>
    );
  }

  return null;
};
